import {
  ComingNomenclatureFare,
  ComingNomenclatureFareRequest,
  ComingNomenclatureMain,
  ComingNomenclatureSalaryRequest,
  ComingNomenclatureTransport,
  ComingNomenclatureTransportCreateRequest,
  ComingNomenclatureTransportDetail,
  SalaryAdjustments,
  Status,
} from 'bus/comingNomenclatureMain/types';

import $axios from '../utils/axios-instance';

export default class ContractorsApi {
  async comingNomenclatureMainList() {
    return await $axios
      .get<{ data: ComingNomenclatureMain[] }>('/v1/ComingNomenclature')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureMainDetail({ id }: { id: number | string }) {
    return await $axios
      .get<ComingNomenclatureMain>(`/v1/ComingNomenclature/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureMainEdit(data: ComingNomenclatureMain) {
    return await $axios
      .put(`/v1/ComingNomenclature/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureMainCreate(data: ComingNomenclatureMain) {
    return await $axios
      .post('/v1/ComingNomenclature/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureMainDelete({ id }: { id: number | string }) {
    return await $axios
      .delete(`/v1/ComingNomenclature/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureStatus() {
    return await $axios
      .get<Status[]>('/v1/ComingNomenclature/statuses/')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureFare({ transportId, dateBegin, dateEnd }: ComingNomenclatureFareRequest) {
    return await $axios
      .get<ComingNomenclatureFare>(
        `/v1/ComingNomenclature/fare/${transportId}?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      )
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureSalary({ driverId, dateBegin, dateEnd }: ComingNomenclatureSalaryRequest) {
    return await $axios
      .get<ComingNomenclatureFare>(`/v1/driverSalary/${driverId}/details?dateBegin=${dateBegin}&dateEnd=${dateEnd}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async driverMixerSalary({ driverId, dateBegin, dateEnd }: ComingNomenclatureSalaryRequest) {
    return await $axios
      .get<ComingNomenclatureFare>(
        `/v1/driverMixerSalary/${driverId}/details?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      )
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureSalaryAdjustments({ driverId, dateBegin, dateEnd }: ComingNomenclatureSalaryRequest) {
    return await $axios
      .get<SalaryAdjustments[]>(
        `/v1/ComingNomenclature/salary/${driverId}/adjustments?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
      )
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async comingNomenclatureTransportList() {
    return await $axios
      .get<{ data: ComingNomenclatureTransport[] }>('/v1/ComingNomenclature/')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureTransportDeteil({ id }: { id: number | string }) {
    return await $axios
      .get<ComingNomenclatureTransportDetail>(`/v1/ComingNomenclature/details/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureTransportDelete({ id }: { id: number | string }) {
    return await $axios
      .delete(`/v1/ComingNomenclature/details/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureTransportCreate(data: ComingNomenclatureTransportCreateRequest) {
    return await $axios
      .post(`/v1/ComingNomenclature/${data.comingId}/details`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
  async comingNomenclatureTransportChange(data: ComingNomenclatureTransportCreateRequest) {
    return await $axios
      .put(`/v1/ComingNomenclature/details/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
